import React, { useEffect } from 'react';
import { Button } from '../components/ui/Button';
import { ArrowRight } from 'lucide-react';
import { useSpotCountdown } from '../hooks/useSpotCountdown';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { useDeadlineCountdown } from '../hooks/useDeadlineCountdown';
export function CheckoutPage() {
  const {
    spots
  } = useSpotCountdown();
  const {
    trackCustomEvent
  } = useMetaPixel();
  const countdown = useDeadlineCountdown();
  useEffect(() => {
    trackCustomEvent('Checkout-Page-Vist');
  }, [trackCustomEvent]);
  const handleCheckout = () => {
    trackCustomEvent('Initiate-Checkout-97');
    window.location.href = 'https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5';
  };
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#FAFAFA] p-4" data-id="element-11">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-12">
        {/* Header Section */}
        <div className="p-8 sm:p-10 text-center space-y-6" data-id="element-13">
          <div className="space-y-2" data-id="element-14">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-15">
              48 Hrs AI CASH MACHINE
            </h1>
            <p className="text-gray-500 text-lg" data-id="element-16">Acceso Completo al Programa</p>
          </div>

          <div className="py-6" data-id="element-17">
            {/* Spots Countdown */}
            <div className={`text-xl font-bold uppercase tracking-wider mb-4 transition-colors duration-300 ${spots === 1 ? 'text-red-600 animate-flash' : 'text-emerald-600'}`} data-id="element-18">
              🔥 Solo {spots}{' '}
              {spots === 1 ? 'Cupo Disponible' : 'Cupos Disponibles'}
            </div>

            <div className="text-sm uppercase tracking-wider text-gray-500 font-semibold mb-2" data-id="element-19">
              Precio Especial
            </div>
            <div className="text-5xl font-bold text-gray-900 tracking-tight" data-id="element-20">
              $97
            </div>
            <div className="mt-1 text-sm text-gray-400 line-through" data-id="element-21">$997</div>
          </div>

          {/* Deadline Countdown Timer */}
          {!countdown.isExpired && <div className="bg-gray-900 rounded-xl p-4 space-y-2" data-id="element-22">
              <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold" data-id="element-23">
                ⏳ El precio sube a $997 en
              </p>
              <div className="flex justify-center gap-3" data-id="element-24">
                <div className="flex flex-col items-center" data-id="element-25">
                  <span className="text-2xl font-bold text-white tabular-nums" data-id="element-26">
                    {pad(countdown.days)}
                  </span>
                  <span className="text-[10px] uppercase text-gray-500" data-id="element-27">
                    Días
                  </span>
                </div>
                <span className="text-2xl font-bold text-gray-600" data-id="element-28">:</span>
                <div className="flex flex-col items-center" data-id="element-29">
                  <span className="text-2xl font-bold text-white tabular-nums" data-id="element-30">
                    {pad(countdown.hours)}
                  </span>
                  <span className="text-[10px] uppercase text-gray-500" data-id="element-31">
                    Hrs
                  </span>
                </div>
                <span className="text-2xl font-bold text-gray-600" data-id="element-32">:</span>
                <div className="flex flex-col items-center" data-id="element-33">
                  <span className="text-2xl font-bold text-white tabular-nums" data-id="element-34">
                    {pad(countdown.minutes)}
                  </span>
                  <span className="text-[10px] uppercase text-gray-500" data-id="element-35">
                    Min
                  </span>
                </div>
                <span className="text-2xl font-bold text-gray-600" data-id="element-36">:</span>
                <div className="flex flex-col items-center" data-id="element-37">
                  <span className="text-2xl font-bold text-white tabular-nums" data-id="element-38">
                    {pad(countdown.seconds)}
                  </span>
                  <span className="text-[10px] uppercase text-gray-500" data-id="element-39">
                    Seg
                  </span>
                </div>
              </div>
            </div>}

          <Button onClick={handleCheckout} size="lg" className="w-full text-lg font-semibold h-16" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-41" />} data-id="element-40">
            Comprar Ahora
          </Button>
          <div className="flex justify-center" data-id="element-42">
            <img src="https://cdn.magicpatterns.com/uploads/8GHLD8cnKemDdH9UnjFrey/IMG_2925.jpg" alt="or 4 payments of $25.25 with Zip" className="h-8 object-contain" data-id="element-43" />
          </div>
          <p className="text-xs text-gray-400 mt-4" data-id="element-44">
            Serás redirigido a nuestra página de pago segura.
          </p>
        </div>
      </div>

      {/* Footer minimal */}
      <div className="mt-8 text-center text-gray-400 text-sm" data-id="element-45">
        &copy; {new Date().getFullYear()} 48 Hrs AI Cash Machine. Todos los
        derechos reservados.
      </div>
    </div>;
}